<template>
    <div class="tipo_venta">
        <div class="tipo">
            <div class=" form-group">
                <div class="input-group">
                    <label for="tipo">Tipo Venta</label>
                    <select @change="selectTipoVenta" v-model="model.tipo_venta" name="" id="tipo">
                        <option value="">Seleccione...</option>
                        <option v-for="item in tiposVenta" :value="item.value">{{item.title}}</option>
                    </select>
                    <i class="bar"></i>
                </div>
            </div>
        </div>
        <!--FACTURA-->
        <div class="factura">
            <div class="form-group" v-if="model.tipo_venta === 'factura'">
                <div class="input-group">
                    <input-comp v-model="model.factura_guia_referencia" label="Guia Referencia"/>
                </div>
                <div class="input-group">
                    <input-comp v-model="model.factura_oc_referencia" label="Oc Referencia"/>
                </div>
            </div>
            <div class="form-group" v-if="model.tipo_venta === 'factura'">
                <div class="input-group">
                    <label for="observacion">Observacion</label>
                    <textarea id="observacion" v-model="model.factura_observacion"></textarea>
                    <i class="bar"></i>
                </div>
            </div>
        </div>

        <div class="abono">
            <div v-show="model.tipo_venta ==='encargo'" class="form-group">
                <div class="input-group">
                    <input-comp v-model="model.abono" :required="true" label="Abono"/>
                </div>
            </div>
        </div>

        <div class="guia">
            <div class="form-group" v-if="model.tipo_venta === 'guia-despacho'">
                <div class="input-group">
                    <label for="traslado">Traslado</label>
                    <select v-model="model.traslado" id="traslado">
                        <option value="">Seleccione...</option>
                        <option value="operacion_constituye_venta">Operación Constituye Venta</option>
                        <option value="ventas_por_efectuar">Ventas por Efectuar</option>
                        <option value="consignaciones">Consignaciones</option>
                        <option value="entrega_gratuita">Entrega Gratuita</option>
                        <option value="traslados_internos">Traslados Internos</option>
                        <option value="otros_traslados_no_venta">Otros Traslados (no venta)</option>
                        <option value="guia_devolucion">Guia de Devolución</option>
                    </select>
                    <i class="bar"></i>
                </div>
            </div>
            <div class="form-group" v-if="model.tipo_venta === 'guia-despacho'">
                <div class="input-group">
                    <label for="despacho">Despacho</label>
                    <select v-model="model.despacho" id="despacho">
                        <option value="">Sin Despacho</option>
                        <option value="despacho_por_cuenta_del_receptor_del_documento">Despacho por
                            cuenta
                            del
                            receptor del documento
                        </option>
                        <option value="despacho_por_cuenta_del_emisor_a_instalaciones">Despacho por
                            cuenta
                            del emisor a instalaciones del cliente
                        </option>
                        <option value="despacho_por_cuenta_del_emisor_a_otras_instalaciones">Despacho
                            por
                            cuenta del emisor a otras instalaciones
                        </option>
                    </select>
                    <i class="bar"></i>
                </div>
            </div>
            <div class="form-group" v-if="model.tipo_venta === 'guia-despacho'">
                <div class="input-group">
                    <label for="obser">Observación</label>
                    <textarea v-model="model.observaciones_guia" id="obser"></textarea>
                    <i class="bar"></i>
                </div>
            </div>
        </div>

        <div class="forma_pago">
            <div class="form-check" v-for="item in formaPago">
                <input :disabled="item.disabled" class=" form-check-input"
                       type="checkbox"
                       v-model="model.formaPagoSeleccionada" :value="item.value" :id="item.id">
                <label class="form-check-label" :for="item.id">{{item.label}}</label>
            </div>
        </div>
    </div>

    <!--    <div class="tipo_venta">-->
    <!--        <div class="tipo">-->
    <!--            <div class=form-group">-->
    <!--                <div class="input-group">-->
    <!--                    <label for="tipo_venta">Tipo venta</label>-->
    <!--                    <select @change="selectTipoVenta" v-model="model.tipo_venta" name="tipo_venta" id="tipo_venta">-->
    <!--                        <option value="">Seleccione...</option>-->
    <!--                        <option v-for="item in tiposVenta" :value="item.value">{{item.title}}-->
    <!--                        </option>-->
    <!--                    </select>-->
    <!--                    <i class="bar"></i>-->
    <!--                </div>-->
    <!--                &lt;!&ndash; ABONO &ndash;&gt;-->
    <!--                <div class="abono form-group" v-show="model.tipo_venta ==='encargo'">-->
    <!--                    <div class="input-group">-->
    <!--                        <input-comp v-model="model.abono" :required="true" label="Abono"></input-comp>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                &lt;!&ndash;FACTURA ELECTRONICA&ndash;&gt;-->
    <!--                <div class="factura form-group" v-if="model.tipo_venta === 'factura'">-->
    <!--                    <div class="input-group">-->
    <!--                        <input-comp v-model="model.factura_guia_referencia" label="Guia Referencia"/>-->
    <!--                    </div>-->
    <!--                    <div class="input-group">-->
    <!--                        <input-comp v-model="model.factura_oc_referencia" label="Oc Referencia"/>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="factura form-group" v-if="model.tipo_venta === 'factura'">-->
    <!--                    <div class="input-group">-->
    <!--                        <label for="observacion">Observacion</label>-->
    <!--                        <textarea id="observacion" v-model="model.factura_observacion"></textarea>-->
    <!--                        <i class="bar"></i>-->
    <!--                    </div>-->
    <!--                </div>-->


    <!--                &lt;!&ndash; GUIA DE DESPACHO &ndash;&gt;-->

    <!--                <div class="guia form-group" v-if="model.tipo_venta === 'guia-despacho'">-->
    <!--                    <div class="input-group">-->
    <!--                        <label for="traslado">Traslado</label>-->
    <!--                        <select v-model="model.traslado" id="traslado">-->
    <!--                            <option value="">Seleccione...</option>-->
    <!--                            <option value="operacion_constituye_venta">Operación Constituye Venta</option>-->
    <!--                            <option value="ventas_por_efectuar">Ventas por Efectuar</option>-->
    <!--                            <option value="consignaciones">Consignaciones</option>-->
    <!--                            <option value="entrega_gratuita">Entrega Gratuita</option>-->
    <!--                            <option value="traslados_internos">Traslados Internos</option>-->
    <!--                            <option value="otros_traslados_no_venta">Otros Traslados (no venta)</option>-->
    <!--                            <option value="guia_devolucion">Guia de Devolución</option>-->
    <!--                        </select>-->
    <!--                        <i class="bar"></i>-->
    <!--                    </div>-->
    <!--                    <div class="input-group">-->
    <!--                        <label for="despacho">Despacho</label>-->
    <!--                        <select v-model="model.despacho" id="despacho">-->
    <!--                            <option value="">Sin Despacho</option>-->
    <!--                            <option value="despacho_por_cuenta_del_receptor_del_documento">Despacho por-->
    <!--                                cuenta-->
    <!--                                del-->
    <!--                                receptor del documento-->
    <!--                            </option>-->
    <!--                            <option value="despacho_por_cuenta_del_emisor_a_instalaciones">Despacho por-->
    <!--                                cuenta-->
    <!--                                del emisor a instalaciones del cliente-->
    <!--                            </option>-->
    <!--                            <option value="despacho_por_cuenta_del_emisor_a_otras_instalaciones">Despacho-->
    <!--                                por-->
    <!--                                cuenta del emisor a otras instalaciones-->
    <!--                            </option>-->
    <!--                        </select>-->
    <!--                        <i class="bar"></i>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--                <div class="guia form-group" v-if="model.tipo_venta === 'guia-despacho'">-->
    <!--                    <div class="input-group">-->
    <!--                        <label for="obser">Observación</label>-->
    <!--                        <textarea v-model="model.observaciones_guia" id="obser"></textarea>-->
    <!--                        <i class="bar"></i>-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        &lt;!&ndash; FORMA PAGO &ndash;&gt;-->

    <!--        <div class="forma_pago">-->
    <!--            <div class="form-check" v-for="item in formaPago">-->
    <!--                <input :disabled="item.disabled" class=" form-check-input"-->
    <!--                       type="checkbox"-->
    <!--                       v-model="model.formaPagoSeleccionada" :value="item.value" :id="item.id">-->
    <!--                <label class="form-check-label" :for="item.id">{{item.label}}</label>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <br>-->
    <!--        <div class="opciones">-->
    <!--            <h6 style="font-weight: bold">Opciones</h6>-->
    <!--            <div class="barra"></div>-->
    <!--            <br>-->
    <!--            <div class="form-check-inline">-->
    <!--                <input v-model="model.opciones" value="es_garage" type="checkbox" id="garage">-->
    <!--                <label class="form-check-label" for="garage">Es Garage</label>-->
    <!--            </div>-->
    <!--            <div class="form-check-inline">-->
    <!--                <input v-model="model.opciones" value="es_online" type="checkbox" id="online">-->
    <!--                <label class="form-check-label" for="online">Es Online</label>-->
    <!--            </div>-->
    <!--            <div class="form-check-inline">-->
    <!--                <input v-model="model.opciones" value="con_despacho" type="checkbox" id="conDespacho">-->
    <!--                <label class="form-check-label" for="conDespacho">Con Despacho</label>-->
    <!--            </div>-->
    <!--            <div class="form-check-inline">-->
    <!--                <input v-model="model.opciones" value="es_telefonica" type="checkbox" id="telefonica">-->
    <!--                <label class="form-check-label" for="telefonica">Es Telefonica</label>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div class="boton">-->
    <!--            <button @click="aceptar" v-if="model.tipo_venta !== ''-->
    <!--            && model.formaPagoSeleccionada.length !== 0" type="button" class="btn btn-warning btn-micro">-->
    <!--                Aceptar-->
    <!--            </button>-->
    <!--        </div>-->
    <!--    </div>-->
</template>

<script>
    import tiposVenta from '../js/tiposVenta';
    import InputComp from "../../Componentes_Globales/Input/inputComp";
    import VuesticMultiSelect from "../../../vuestic-theme/vuestic-components/vuestic-multi-select/VuesticMultiSelect";
    import FormaPago from "./formaPago";
    import formaPago from "../../Caja/js/formaPago";

    export default {
        name: "tipoVenta",
        components: {FormaPago, VuesticMultiSelect, InputComp},
        data() {
            return {
                model: {
                    tipo_venta: '',
                    abono: 0,
                    factura_guia_referencia: '',
                    factura_oc_referencia: '',
                    factura_observacion: '',
                    despacho: '',
                    observaciones_guia: '',
                    traslado: '',
                    opciones: [],
                    formaPagoSeleccionada: []
                },
                tiposVenta,
                formaPago
            }
        },
        props: {
            tipoVenta: Object
        },
        created() {
            if (this.$route.query.venta_id) {
                this.model.tipo_venta = this.tipoVenta.tipo_venta
                this.model.abono = this.tipoVenta.abono || 0
                this.model.formaPagoSeleccionada = this.tipoVenta.formaPagoSeleccionada
                this.model.opciones = this.tipoVenta.opcionSeleccionada
                this.model.traslado = this.tipoVenta.traslado
                this.model.observaciones_guia = this.tipoVenta.observaciones_guia
                this.model.despacho = this.tipoVenta.despacho
                this.model.factura_guia_referencia = this.tipoVenta.factura_guia_referencia
                this.model.factura_oc_referencia = this.tipoVenta.factura_oc_referencia
                this.model.factura_observacion = this.tipoVenta.factura_observacion
                this.disabledCheck()
            }

        },
        methods: {
            aceptar() {
                if (this.model.tipo_venta === '') {
                    this.$swal('Alerta!', 'Debe seleccionar tipo de venta', 'warning')
                } else if (this.model.formaPagoSeleccionada.length === 0) {
                    this.$swal('Alerta!', 'Debe seleccionar formas de pago', 'warning')
                } else {
                    this.$emit('aceptarTipoVenta', this.model)
                }
            },
            selectTipoVenta() {
                this.model.abono = 0
                this.model.factura_guia_referencia = ''
                this.$emit('select', this.model)
                this.disabledCheck()
            },
            disabledCheck() {
                if (this.model.tipo_venta === 'encargo') {
                    this.formaPago.forEach(item => {
                        item.disabled = item.value === 'cheque'
                            || item.value === 'credito_cliente'
                            || item.value === 'deposito'
                            || item.value === 'nota_credito'
                            || item.value === 'abono';
                    })
                } else if (this.model.tipo_venta === 'boleta' || this.model.tipo_venta === 'factura' || this.model.tipo_venta === 'guia-despacho') {
                    this.formaPago.forEach(item => {
                        item.disabled = false
                    })
                } else if (this.model.tipo_venta === 'cotizacion-formal' || this.model.tipo_venta === 'cotizacion') {
                    this.formaPago.forEach(item => {
                        item.disabled = item.value === 'abono';
                    })
                } else if (this.model.tipo_venta === '') {
                    this.formaPago.forEach(item => {
                        item.disabled = false
                    })
                }
            }
        }

    }
</script>

<style scoped lang="scss">

    @mixin grid {
        grid-column: 1/2;
        grid-row: 2/3;
    }

    .tipo_venta {
        display: grid;
        grid-template-columns: 300px auto auto;
        grid-template-rows: 90.5px auto;
        grid-auto-rows: 1fr;

        .factura, .guia, .abono {
            @include grid
        }

        .forma_pago {
            grid-column: 3/4;
        }

        .boton {
            margin: 30px 0;
        }
    }

    .input-group {
        margin-right: 10px;

        select {
            font-size: 20px;
            cursor: pointer;

            option {
                font-size: 20px;
            }
        }

        .fa {
            margin-right: 10px;
            color: black;
            font-size: 20px;
        }
    }


    .title, h6 {
        font-size: 20px;
        color: #090024;
    }

    .form-check {
        input {
            height: 30px;
            width: 15px;
            cursor: pointer;
            margin-right: 5px;
        }
        label{
            font-size: 19px;
        }
    }

    label {
        font-weight: bold;
    }

    .barra {
        width: 100%;
        height: 5px;
        border-bottom: black 1px solid;
    }

</style>
